import React from 'react'
import { Button } from 'react-bootstrap'
import { ButtonLoader } from '../loader'

export default function ClearButton(props) {

    const { button_name, onClick, spinner } = props

    return (
        <>
            <Button type='button' size='sm' className={localStorage.getItem('lang_key') == 'ar' ? 'me-1 close_btn' : 'ms-1 close_btn'} onClick={onClick}>
                {spinner ? <ButtonLoader /> : button_name}
            </Button>
        </>
    )
}